module.exports = __webpack_public_path__ + "static/image_side_left-a23d9fb1a9effaade3548aba4cccb7bd.svg";